import {Text} from '../../../../../component/text/text';
import {Locale} from '../../../../../provider/locale/locale';
import * as styles from '../lps-rating-status.scss';

interface LpsStatusProps {
    value: number;
}

export function LpsStatus({value}: LpsStatusProps): JSX.Element {
    if (value < 50) {
        return (
            <Text bolder className={styles.LpsRatingStatus_badRating}>
                <Locale stringKey="DASHBOARD_PAGE__LPS_RATING__LOW" />
            </Text>
        );
    }

    if (value < 80) {
        return (
            <Text bolder className={styles.LpsRatingStatus_mediumRating}>
                <Locale stringKey="DASHBOARD_PAGE__LPS_RATING__MEDIUM" />
            </Text>
        );
    }

    return (
        <Text bolder className={styles.LpsRatingStatus_goodRating}>
            <Locale stringKey="DASHBOARD_PAGE__LPS_RATING__HIGH" />
        </Text>
    );
}
